
    <app-station-tile class="station-item" styleClass="empty-working-station"
        [ngClass]="{'highlight': sacClientContext?.triggerHighlightNewTransports}" [height]="149"
        [isDisabled]="station.stationUsage.disabled"
        [suspended]="station.stationUsage.suspended || station.stationUsage.loadingZoneLock" [selected]="selected"
        *ngIf="station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 0">
        <app-empty-workingarea-item [station]="station" [selected]="selected">
        </app-empty-workingarea-item>
        <div class="hint">
            <div class="faulty-indicator" *ngIf="station.stationUsage.faulty"><i
                    class="fa-light fa-triangle-exclamation"></i></div>
            <div class="available-truck-indicator" *ngIf="station.stationUsage.transportsAvailable"><i
                    class="fa-light fa-truck-container"></i></div>
            <sc-content-spacer grow></sc-content-spacer>
            <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
                *ngIf="station.stationUsage.suspended && selected"></sc-icon>
            <sc-icon iconClass="fa-lock" (click)="startSuspension()"
                *ngIf="!station.stationUsage.suspended && station.stationUsage.transports.length === 0 && !station.stationUsage.disabled && selected && !station.stationUsage.loadingZoneLock"></sc-icon>
        </div>
    </app-station-tile>

    <app-station-tile class="station-item" styleClass="used-working-station"
        [ngClass]="{'highlight': sacClientContext?.triggerHighlightNewTransports}" [height]="149" [selected]="selected"
        *ngIf="station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 1">
        <app-used-workingarea-item [station]="station" [selected]="selected">
        </app-used-workingarea-item>
        <div class="hint">
            <div class="faulty-indicator" *ngIf="station.stationUsage.faulty"><i
                    class="fa-light fa-triangle-exclamation"></i></div>
            <div class="available-truck-indicator"
                *ngIf="station.stationUsage.plannedTransportAssignmentPossible && station.stationUsage.transportsAvailable">
                <sc-icon iconClass="fa-truck-container"></sc-icon>
            </div>
            <sc-content-spacer grow></sc-content-spacer>
            <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
                *ngIf="station.stationUsage.suspended && selected"></sc-icon>
            <sc-icon iconClass="fa-lock" (click)="startSuspension()"
                *ngIf="!station.stationUsage.suspended && !station.stationUsage.disabled && selected"></sc-icon>
        </div>
    </app-station-tile>

    <app-station-tile class="station-item" styleClass="waiting-area" [height]="149" [selected]="selected"
        *ngIf="station.stationType === stationType.WAITING_AREA">
        <app-waiting-area-item [station]="station" [selected]="selected">
        </app-waiting-area-item>
    </app-station-tile>
